
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useTranslation from "next-translate/useTranslation";
import NarrowPage from "../../components/layout/narrow-page";
import Head from "next/head";
import RegisterPageContent from "@/modules/register/RegisterPageContent";
import { useState, useEffect } from "react";
export default function RegisterPage() {
    const { t } = useTranslation("common");
    const { t: registerT } = useTranslation("auth");
    const [step, setStep] = useState<"form" | "username" | "socialUsername" | "joined">("form");
    const [pageTitle, setPageTitle] = useState(t("Create free account") as string);
    const [subtitle, setSubtitle] = useState<string | null>();
    // registerT("Continue with your favorite account")
    useEffect(() => {
        // Update title and subtitle based on step
        if (step === "joined") {
            setPageTitle("");
            setSubtitle(null);
        }
        else if (step === "socialUsername") {
            setPageTitle(registerT("Choose your username"));
            setSubtitle(registerT("Your username will be visible to other users"));
        }
        else if (step === "username") {
            setPageTitle(registerT("Choose your username"));
            setSubtitle(registerT("Your username will be visible to other users"));
        }
        else {
            setPageTitle(t("Create free account"));
            // setSubtitle(registerT("Continue with your favorite account"));
        }
    }, [step, t, registerT]);
    return (<>
      <Head>
        <title>{"Chess Hotel | " + t("Create free account")}</title>
        <meta name="description" content={t("description")}/>
        <meta name="keywords" content={t("keywords")}/>
      </Head>
      <NarrowPage title={null}>
        {pageTitle && (<div className="text-lg font-semibold text-center md:text-xl md:text-left">
            {pageTitle}
          </div>)}
        {subtitle ? (<div className="mt-2 text-sm text-center md:text-sm text-altgray-600 md:text-left">
            {subtitle}
          </div>) : (<div className="h-0"></div>)}
        <div className="mt-7">
          <RegisterPageContent onStepChange={setStep}/>
        </div>
      </NarrowPage>
    </>);
}

    async function __Next_Translate__getStaticProps__19e6f0142dd__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/register/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19e6f0142dd__ as getStaticProps }
  